module.exports = __webpack_public_path__ + "img/aviation_mix1.c5dc7433.jpg";